import request from './axios.config'

/**
 * 获取用户列表
 * get
 * **/
export const getUserByCustId = (params) => {
    return request({
        url: `/npgw/api/analysis/getUserByCustId`,
        method: 'get',
        params
    })
}
/**
 * 查询24网站会员中心用户信息
 * get
 * **/
export const findOneByMemerCode = (params) => {
    return request({
        url: `/npgw/api/analysis/findOneByMemerCode`,
        method: 'get',
        params
    })
}
/**
 * 获取内容分析列表
 * post
 * **/
export const getFixListData = (params, data) => {
    return request({
        url: `/npgw/api/analysis/getFixListData`,
        method: 'post',
        params,
        data
    })
}
/**
 * 导出提交
 * post
 * **/
export const commitTask = (params, data) => {
    return request({
        url: `/npgw/api/analysis/commitTask`,
        method: 'post',
        params,
        data
    })
}
/**
 * 导出记录列表
 * post
 * **/
export const getCustomBatchList = (params, data) => {
    return request({
        url: `/npgw/api/analysis/getCustomBatchList`,
        method: 'post',
        params,
        data
    })
}
/**
 * 下载导出记录
 * get
 * **/
export const download = (params) => {
    return request({
        url: `/npgw/api/analysis/download`,
        method: 'get',
        params,
        responseType: 'blob',
    })
}